import { render, staticRenderFns } from "./GroupCreatorWidgetSimplified.vue?vue&type=template&id=5003f2f2&scoped=true"
import script from "./GroupCreatorWidgetSimplified.vue?vue&type=script&lang=js"
export * from "./GroupCreatorWidgetSimplified.vue?vue&type=script&lang=js"
import style0 from "./GroupCreatorWidgetSimplified.vue?vue&type=style&index=0&id=5003f2f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5003f2f2",
  null
  
)

export default component.exports